  import React, { useState, useEffect, createRef } from "react";
  import {
    TextArea,
    Dropdown,
    Input,
    Form,
    Button,
    Divider,
    Dimmer,
    Loader,
    Checkbox,
    Image,
  } from "semantic-ui-react";
  import * as auth from "../../modules/Auth/_redux/authRedux";
  import { PhoneInput } from "react-international-phone";
  import { PhoneNumberUtil } from "google-libphonenumber";
  import location_icon from "../../../Assets/Icons/location_on.jpg";
  import sub_location_icon from "../../../Assets/Icons/pin_drop.png";
  import { useCancelModal } from "../../../hooks/Messages/useCancelModal";
  
  import { Country, State } from "country-state-city";
  import { useDispatch, useSelector, connect } from "react-redux";
  import { toast } from "react-toastify";
  import { selectTranslations } from "../../config/i18n/slice";
  import { scrollToError } from "../../../utilFunctions/scrollToError";
  import {
    AddIcon,
    AddIconWithCircle,
    BillingInfoIcon,
    CloseIcon,
    ContactInfoIcon,
    DeleteIcon,
    EditWhiteIcon,
    ImgPhotos,
    InfoIcon,
    InfoIconBlue,
    TextSnippet,
  } from "../../../Assets/Icons/svg";
  import Asterisk from "../../components/common/Asterisk";
  import { useDropzone } from "react-dropzone";
  import ToolTip from "react-power-tooltip";
  import { fetchCustomerInitData } from "../../../redux/reducers/customerReducer";
  import { Resizable } from "re-resizable";
  import useNewCancelModal from "../../../hooks/Messages/useNewCncelModal";
  import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
  import AddLocation from "../Locations/add";
  import ImageCrop from "../MyCompanyProfile/ImageCrop";
  import { createNewCustomer } from "../../config/api/customerApis";
  import { getAllParentLocations } from "../../config/sharedApi/locationApis";
  import {
    handleKeyDown,
  } from "../../config/common/commonFunctions";
  import { uploadFile } from "../../config/api/configApis";
  import { getUserData } from "../../config/sharedApi/peopleApis";
  import { currencies } from "../../config/common/commonVariables";
  import {
    buildValidation,
    makeOnBlurFactory,
    makeOnValuesChangeFactory,
    makeValidateOnSubmitFactory,
  } from "./customersValidationRules";

  const phoneUtil = PhoneNumberUtil.getInstance();

  /*
   * The function `isPhoneValid` checks if a phone number is valid using the Google's libphonenumber library in JavaScript.
   */
  const isPhoneValid = (phone) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };
  
  /*
   * The FileUpload function in JavaScript handles file uploads with customizable drag and drop functionality.
   */
  const FileUpload = ({
    onFileChange,
    name = "",
    attachments = {},
    setAttachments = () => {},
    setImageSrc = () => {},
    setFile = () => {},
    setPersonalImgId = () => {},
  }) => {
    const fileTypes = {
      images: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/svg+xml",
        "image/webp",
        "image/heic",
      ],
      documents: [
        "text/plain",
        "application/pdf",
        "text/csv",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
      video: ["video/mp4", "video/quicktime", "video/webm", "video/hevc"],
    };
  
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles) => {
        const allowedFileTypes = [...fileTypes.images];
  
        // Validate file types
        const invalidFiles = acceptedFiles.filter(
          (file) => !allowedFileTypes.includes(file.type)
        );
  
        // Show toast if there are invalid files
        if (invalidFiles?.length > 0) {
          toast.error(t.common.invalid_msg);
          return;
        }
  
        let totalSize = organisationImage?.attachmentsSize
          ? organisationImage?.attachmentsSize
          : 200;
        const validFiles = acceptedFiles.filter((file) => {
          const isImage = fileTypes.images.includes(file.type);
          const isDocument = fileTypes.documents.includes(file.type);
  
          const isVideo = fileTypes.video.includes(file.type);
  
          const validSize =
            (isVideo || isImage || isDocument) &&
            file.size < totalSize * 1024 * 1024;
  
          if (!validSize) {
            toast.error(
              `${t.common.file_upload_valid} ${totalSize} ${t.common.file_upload_second}`
            );
            return false;
          }
          return true;
        });
  
        onFileChange(validFiles, name);
      },
    });
    const t = useSelector(selectTranslations);
    const organisationImage = useSelector((state) => {
      if (state?.auth?.user?.organisation) {
        return state.auth.user.organisation;
      } else {
        return null;
      }
    });
  
    const selectedLanguage = useSelector((state) => {
      if (state?.i18n?.lang) {
        return state.i18n.lang;
      } else {
        return "en";
      }
    });
    //TO DO : Customize and Style this Drag and Drop to Upload box as you want🧑‍💻😊
    return (
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {name === "image" ? (
          attachments?.image?.name ? (
            <div className="user-img-avatar position-relative">
              <Image
                avatar
                title={attachments?.image?.name}
                src={`${attachments?.image?.url}`}
              ></Image>
              <span
                className={`people-circle-image ${
                  selectedLanguage == "en" ? "" : "rtl-people"
                }`}
              >
                <span
                  className={`edit-container ${
                    selectedLanguage == "en" ? "" : "rtl-edit"
                  }`}
                >
                  <EditWhiteIcon /> {t.common.edit}
                </span>
              </span>
  
              <span
                className="ml-3 mr-3 c-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setPersonalImgId(null);
                  setFile("");
                  setImageSrc("");
                  setAttachments({
                    ...attachments,
                    image: null,
                  });
                }}
              >
                <DeleteIcon />
              </span>
            </div>
          ) : (
            <div className="image-dropzone  text-center mb-5">
              <div>
                <p className="p1">
                  <div className="d-flex align-items-start justify-content-center ">
                    <div>
                      {" "}
                      <ImgPhotos />
                    </div>
                    <div
                      className={`mr-2 ml-2 ${
                        selectedLanguage == "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {" "}
                      <div className="blue-text"> {t.common.upload_img}</div>{" "}
                      <p className="mb-0 files-text">
                        {" "}
                        {t.common.valid_files_img}
                      </p>{" "}
                    </div>
                  </div>
                </p>
              </div>
            </div>
          )
        ) : attachments?.warrantyFile?.name ? (
          <div className="warrenty-file-dropzone text-center">
            <label>
              {attachments?.warrantyFile?.name}
              <span
                className="ml-3 mr-3 c-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setAttachments({
                    ...attachments,
                    warrantyFile: null,
                  });
                }}
              >
                <DeleteIcon />
              </span>
            </label>
          </div>
        ) : (
          <div className="warrenty-file-dropzone d-flex align-items-center justify-content-between">
            <div className="d-flex ml-4 mr-4">
              <TextSnippet />
              <div className="pl-4 pr-4">
                <p className="p1 m-0">Warranty file</p>
                <p className="p2 m-0">Attach a file to this asset</p>
              </div>
            </div>
            <div>
              <AddIconWithCircle />
            </div>
          </div>
        )}
      </div>
    );
  };
  function Add(props) {
    const {
      toggled,
      setToggleAddModal,
      untoggle,
      refresh,
      setRefresh,
      setFilterOptions,
      setSearchTitle,
      role,
      allIds,
      setAllIds,
    } = props;
  
    const t = useSelector(selectTranslations);
    const { setCancelModal, CancelModal } = useCancelModal();
    const { setNewCancelModal, NewCancelModal } = useNewCancelModal();
    const [showTeamsTooltip, setTeamsTooltip] = useState(false);
    const selectedLanguage = useSelector((state) => {
      if (state?.i18n?.lang) {
        return state.i18n.lang;
      } else {
        return "en";
      }
    });
    const [personalImgId, setPersonalImgId] = useState();
    const organisationId = useSelector((state) => {
      if (state?.auth?.user?.organisation) {
        return state.auth.user.organisation.id;
      } else {
        return null;
      }
    });
  
    const { initData } = useSelector((state) => ({
      initData: state.customer.customerInitData,
    }));
  
    const currentUserId = useSelector((state) => {
      if (state?.auth?.user?.id) {
        return state.auth.user.id;
      } else {
        return null;
      }
    });
  
    const [toggleAsideModal, setToggleAsideModal] = useState(false);
    const { userPermissions } = usePermissionsSimplified();
    const [file, setFile] = useState(""); //
    const [initChange, setInitChange] = useState(false);
    const dispatch = useDispatch();
    const [showCancleTooltip, setCancleTooltip] = useState(false);
    const [phone, setPhone] = useState(null);
    const [activePane, setActivePane] = useState(0);
    const [isLoadingActive, activateLoading] = useState(false);
    const [buttonStatus, setButtonStatus] = useState(0);
    const [modalWidth, setModalWidth] = useState(
      Math.max(window.innerWidth / 2, 514)
    );
  
    const logoRef = createRef();
    const [imageSrc, setImageSrc] = useState("");
    const [responseData, setResponseData] = useState({});
    const [fetchingCountries, setFetchingCountries] = useState(true);
    const [options, setOptions] = useState({
      locations: {
        initOptions: [],
        options: [],
      },
      Industry: [
        {
          key: "industry1",
          value: "Commercial Real Estate Companies",
          text: t.customers.industry.commercial,
        },
        {
          key: "industry2",
          value: "Corporate Offices",
          text: t.customers.industry.corporate,
        },
        {
          key: "industry3",
          value: "Manufacturing Companies",
          text: t.customers.industry.manufacturing,
        },
        {
          key: "industry4",
          value: "Healthcare Organizations",
          text: t.customers.industry.healthcare,
        },
        {
          key: "industry5",
          value: "Educational Institutions",
          text: t.customers.industry.educational,
        },
        {
          key: "industry6",
          value: "Government and Public Sector Organizations",
          text: t.customers.industry.government,
        },
        {
          key: "industry7",
          value: "Hospitality and Entertainment Companies",
          text: t.customers.industry.hospitality,
        },
        {
          key: "industry8",
          value: "Data Centers",
          text: t.customers.industry.data_centers,
        },
        {
          key: "industry9",
          value: "Retail Companies",
          text: t.customers.industry.retails,
        },
        {
          key: "industry10",
          value: "Sports and Recreation Facilities",
          text: t.customers.industry.sports,
        },
      ],
    });
    const [customerData, setCustomerData] = useState({
      name: "",
      address: "",
      location: [],
      selectedLocation: [],
      countryCode: "962",
      phone: "",
      website: "",
      email: "",
      isSame: false,
      serviceType: "",
      description: "",
      countries_options: [],
      country: "",
      cities_options: [],
      city: "",
      billing_name: "",
      billing_postal_code: "",
      billing_address: "",
      billing_addressLine2: "",
      billing_addressLine3: "",
      billing_rate: 0,
      billing_currency: "JOD",
      Industry: "",
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    });
  
    const [attachments, setAttachments] = useState({
      image: null,
    });
  
    /*
     * The function `fetchLocationsOptions` fetches all locations for a given organisation and returns them as options with keys, values, and text.
     */
    const fetchLocationsOptions = async (updatedAllIds = []) => {
      setOptions({
        ...options,
        locations: {
          initOptions: [],
          options: [],
        },
      });
  
      let finalIds = [...allIds];
  
      if (updatedAllIds?.length > 0) {
        finalIds = [...updatedAllIds];
      }
      const fetchData = await getAllParentLocations(
        organisationId,
        "",
        1,
        99999,
        [],
        [],
        [],
        ["name:asc"]
      );
      let the_options = [];
      let parentOptions = [];
      let subOptions = [];
      if (fetchData?.response?.length > 0) {
        fetchData.response.forEach((el) => {
          if (!(role === "super_admin")) {
            if (finalIds?.includes(el.id)) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: false,
              });
  
              if (el?.attributes?.subLocations?.data?.length > 0) {
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (finalIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
              }
            } else {
              const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
                (subEl) => finalIds?.includes(subEl.id)
              );
  
              if (hasMatchingSubLocation) {
                parentOptions.push({
                  key: el.id,
                  value: el.id,
                  text: el.attributes.name,
                  image: { src: location_icon },
                  className: "main-location-dropdown-option",
                  disabled: true,
                });
  
                // Collect matching sub-options
                el?.attributes?.subLocations?.data?.length > 0 &&
                  el.attributes.subLocations.data.forEach((subEl) => {
                    if (finalIds?.includes(subEl.id)) {
                      subOptions.push({
                        key: subEl.id,
                        value: subEl.id,
                        text: subEl.attributes.name,
                        image: { src: sub_location_icon },
                        className: "sub-location-dropdown-option",
                        parentId: el.id,
                      });
                    }
                  });
              }
            }
          } else {
            parentOptions.push({
              key: el.id,
              disabled: false,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
            });
  
            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                subOptions.push({
                  key: subEl.id,
                  value: subEl.id,
                  text: subEl.attributes.name,
                  image: { src: sub_location_icon },
                  className: "sub-location-dropdown-option",
                  parentId: el.id,
                });
              });
            }
          }
        });
  
        // Sort sub-options alphabetically
        subOptions.sort((a, b) => a.text.localeCompare(b.text));
  
        // Merge parent options with sorted sub-options
        parentOptions.forEach((parentOption) => {
          the_options.push(parentOption);
          // Add sorted sub-options belonging to this parent
          subOptions.forEach((subOption) => {
            if (subOption.parentId === parentOption.key) {
              the_options.push(subOption);
            }
          });
        });
  
        // Update the options state
        setOptions((prev) => ({
          ...prev,
          locations: {
            initOptions: the_options,
            options: the_options,
          },
  
          // the_options,
        }));
  
        return the_options;
      }
    };
  
    const user = useSelector((state) => {
      //console.log(state);
      if (state?.auth?.user) {
        return state.auth.user;
      } else {
        return null;
      }
    });
  
    const fetchCountriesOptions = () => {
      const countries = Country.getAllCountries();
      if (countries) {
        const _g_options = countries.map((el) => {
          return {
            key: el?.isoCode?.toLowerCase(),
            value: el?.isoCode,
            text: el.name,
            flag: el?.isoCode?.toLowerCase(),
          };
        });
  
        setCustomerData({
          ...customerData,
          countries_options: _g_options,
        });
      }
    };

    const [validation, setValidation] = useState(() => buildValidation(t));
  
    /*
     * The `resetForm` function resets all form fields, validation messages, modal width, attachments, and sets the active pane to the initial state.
     */
    const resetForm = () => {
      setCustomerData({
        name: "",
        address: "",
        location: [],
        selectedLocation: [],
        contact_name: "",
        contact_phone: "",
        contact_email: "",
        countryCode: "962",
        phone: "",
        website: "",
        email: "",
        isSame: false,
        serviceType: "",
        description: "",
        countries_options: [],
        country: "",
        cities_options: [],
        city: "",
        billing_name: "",
        billing_postal_code: "",
        billing_address: "",
        billing_addressLine2: "",
        billing_addressLine3: "",
        billing_rate: 0,
        billing_currency: "JOD",
        Industry: "",
      });
      setValidation(buildValidation(t));
  
      setModalWidth(Math.max(window.innerWidth / 2, 514));
  
      setInitChange(false);
      setAttachments({
        image: null,
      });
      setFile("");
      setImageSrc("");
      setPersonalImgId(null);
      setActivePane(0);
    };
  
    /*
     * The `onFileChange` function sets a new file attachment with random ID and details when a file is selected.
     */
    const onFileChange = (files, name) => {
      setInitChange(true);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImageSrc(reader.result);
      });
      reader.readAsDataURL(files[0]);
  
      setFile({
        name: files[0]?.name,
        type: files[0]?.type,
      });
    };
    useEffect(() => {
      const countries = Country.getAllCountries();
      if (countries) {
        setFetchingCountries(false);
        const _g_options = countries.map((el) => {
          return {
            key: el?.isoCode?.toLowerCase(),
            value: el?.isoCode,
            text: el.name,
            flag: el?.isoCode?.toLowerCase(),
          };
        });
        setCustomerData((pre) => ({ ...pre, countries_options: _g_options }));
      }
      fetchLocationsOptions();
    }, [toggled]);
  
    const fetchCities = (code) => {
      const fetchData = State.getStatesOfCountry(code);
  
      if (fetchData.length > 0) {
        let the_options = fetchData.map((el) => {
          return {
            key: el.isoCode,
            value: el.isoCode,
            text: el.name,
          };
        });
        setCustomerData({
          ...customerData,
          country: code,
          cities_options: the_options,
        });
      }
    };

    const getCustomerData = () => customerData;
    const getOptions = () => options;

    const makeOnBlur = makeOnBlurFactory({
      getCustomerData,
      setValidation,
    });
  
    /*
     * The function `onValuesChange` handles changes in form field values, updating the customer data and performing validation based on the field type.
     */

    const onValuesChange = makeOnValuesChangeFactory({
      getCustomerData,
      setCustomerData,
      setValidation,
      getOptions,
      setOptions,
      setInitChange,
    });

    const validateAll = makeValidateOnSubmitFactory({
      getCustomerData,
      validation,
      setValidation,
    });


    /* The above code is a React useEffect hook that is triggered whenever the `customerData.country` value
  changes. It fetches the states of a country using the `State.getStatesOfCountry` function and then
  maps the fetched data to create an array of options for cities. If there are states fetched, it sets
  the `cities_options` in the `customerData` state to the mapped options array. If no states are
  fetched, it sets the `cities_options` to an empty array. */
    useEffect(() => {
      const fetchData = State.getStatesOfCountry(customerData.country);
  
      if (fetchData.length > 0) {
        let the_options = fetchData.map((el) => {
          return {
            key: el.isoCode,
            value: el.isoCode,
            text: el.name,
          };
        });
        setCustomerData({
          ...customerData,
          cities_options: the_options,
        });
      } else {
        setCustomerData({
          ...customerData,
          cities_options: [],
        });
      }
    }, [customerData.country]);
  
    /*
     * The `validationHandler` function updates validation properties based on customer data and checks if there are any errors present.
     */
  
    /*
     * The function `createNewCustomerHandler` handles the creation of a new customer by validating data,
     * uploading a logo, and making an API call to create the customer with the provided information.
     */
    const createNewCustomerHandler = async () => {
      const hasErrors = validateAll();
      if (!hasErrors) {
        setButtonStatus(1);
  
        const billingInformation = {
          name: customerData.billing_name,
          country: customerData.country,
          city: customerData.city,
          postalCode: customerData.billing_postal_code,
          address: customerData.billing_address,
          addressLine2: customerData.billing_addressLine2,
          addressLine3: customerData.billing_addressLine3,
          rate: customerData?.billing_rate ? customerData.billing_rate : null,
          currency: customerData.billing_currency || null,
        };
        const contactInformation = {
          name: customerData.contact_name,
          phone: customerData?.contact_phone ? customerData?.contact_phone : null,
          email: customerData?.contact_email ? customerData.contact_email : null,
          isSame: customerData.isSame,
        };
  
        const response = await createNewCustomer(
          customerData.name,
          customerData.phone || null,
          customerData.website,
          customerData.email || null,
          customerData.serviceType,
          customerData.description,
          billingInformation,
          personalImgId,
          organisationId,
          currentUserId,
          customerData.selectedLocation || null,
          customerData.Industry || null,
          contactInformation
        );
  
        if (response.status == 200) {
          setButtonStatus(0);
          untoggle();
          resetForm();
  
          setResponseData({
            name: response.data.name,
          });
          setFilterOptions({
            countries: [],
            cities: [],
            locations: [],
  
            rate: {
              from: null,
              to: null,
            },
          });
          setSearchTitle("");
  
          toast.success(t.customers.customer + " " + t.common.added_success);
  
          if (initData?.length == 0) {
            const fetchData = await dispatch(
              fetchCustomerInitData({ organisationId, role, allIds })
            );
          }
        } else if (response.status == 400) {
          if (response.error && response.error.message) {
            toast.error(response.error.message);
          } else {
            toast.error(t.common.something_wrong);
            untoggle();
            resetForm();
          }
        }
        setButtonStatus(0);
      } else {
        scrollToError();
      }
    };
  
    /*
     * The function `changeTab` switches to a different tab if there are no errors in the data, otherwise it scrolls to the first error.
     */
    const changeTab = async (tab, errors, setFieldTouched, values) => {
      const hasErrors = validateAll();
  
      if (!hasErrors) {
        setActivePane(tab);
        return;
      } else {
        scrollToError();
      }
    };
  
    /*
     * The `cancelHandler` function resets the form, adjusts the modal width, untoggles a modal,deactivates loading, and updates state variables.
     */
    const cancelHandler = () => {
      resetForm();
      setModalWidth(Math.max(window.innerWidth / 2, 514));
      untoggle();
      activateLoading(false);
      setNewCancelModal(false);
      setInitChange(false);
    };
    return (
      <>
        <div
          style={{ maxWidth: `${modalWidth}px` }}
          clearing
          className={
            toggled
              ? "aside-modal preview active procedure"
              : "aside-modal preview procedure"
          }
        >
          <Resizable
            size={{ width: modalWidth, height: "auto" }}
            minWidth={"514px"}
            onResize={(e, direction, ref, d) => {
              setModalWidth(ref.offsetWidth);
            }}
          >
            <div className="modal-header">
              <div className="flexbox justify-between  align-center">
                <div className="name">{t.customers.add_customer}</div>
                <div className="flexbox align-center workorder-header-buttons">
                  <span
                    className="position-relative procedure-header-button c-pointer"
                    onMouseOver={() => setCancleTooltip(true)}
                    onMouseLeave={() => setCancleTooltip(false)}
                    onClick={() =>
                      initChange ? setNewCancelModal(true) : cancelHandler()
                    }
                  >
                    <CloseIcon />
                    <ToolTip
                      color="#fff"
                      backgroundColor="#172B4D"
                      position={
                        selectedLanguage == "en"
                          ? "bottom center"
                          : "bottom center"
                      }
                      show={showCancleTooltip}
                      textBoxWidth="36px"
                      arrowAlign="center"
                      padding="5px 5px 5px 7px"
                      borderRadius="5px"
                      static
                    >
                      <span className="work-order-preview-tooltip">
                        {t.common.close}
                      </span>
                    </ToolTip>
                  </span>
                </div>
              </div>
            </div>
            <div className="body p-6">
              {buttonStatus == 1 ? (
                <Dimmer active inverted>
                  <Loader inverted content={t.common.loading} />
                </Dimmer>
              ) : (
                ""
              )}
              <Button.Group
                className="add-people-btn customer mt-5"
                basic
                fluid
                // style={{ width: "50%" }}
                size="medium"
              >
                <Button
                  active={activePane == 0}
                  onClick={() => changeTab(0)}
                  type="button"
                >
                  {t.customers.table.details}
                </Button>
  
                <Button
                  className="add-people-tab"
                  active={activePane == 1}
                  onClick={() => changeTab(1)}
                  type="button"
                >
                  {t.customers.form.billing_information}
                </Button>
              </Button.Group>
              <Divider
                className="mt-0 customer-divider"
                //  style={{ width: "50%" }}
              />
  
              <div>
                <div className={activePane === 0 ? "d-block" : "d-none"}>
                  <FileUpload
                    onFileChange={onFileChange}
                    name="image"
                    setImageSrc={setImageSrc}
                    setFile={setFile}
                    attachments={attachments}
                    setAttachments={setAttachments}
                  />
  
                  {imageSrc && (
                    <ImageCrop
                      src={imageSrc}
                      minWidth={20}
                      minHeight={20}
                      fileData={file}
                      onAccept={async (croppedImageUrl) => {
                        let CroppedFile = new File([croppedImageUrl], file.name, {
                          type: file.type,
                        });
  
                        var randomnumber =
                          Math.floor(Math.random() * (0 - 100 + 1)) + 100;
  
                        const personalPictureResponse = await uploadFile([
                          CroppedFile,
                        ]);
  
                        if (personalPictureResponse?.status == 200) {
                          let fileData = personalPictureResponse?.data[0]?.url;
                          setPersonalImgId(personalPictureResponse.data[0].id);
                          setImageSrc("");
                          setFile("");
                          setAttachments({
                            ...attachments,
                            ["image"]: {
                              file: CroppedFile,
                              id: randomnumber,
                              name: CroppedFile.name,
                              type: CroppedFile.type,
                              cancelPopup: false,
                              isChanged: true,
                              url: fileData ? fileData : null,
                            },
                          });
                        } else {
                          toast.error(t.common.something_wrong);
                        }
                      }}
                      onCancel={() => {
                        setImageSrc("");
                        setFile("");
                      }}
                    />
                  )}
  
                  <Form.Field>
                    <label className="label-item mt-3">
                      {t.customers.table.name}
                      <Asterisk color="#172B4D" />
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_name}
                      value={customerData.name}
                      onChange={onValuesChange("name")}
                      error={validation.name.error && validation.name.skipped}
                      onBlur={makeOnBlur("name")}
                    />
                    {validation.name.error && validation.name.skipped ? (
                      <div className="label-error">{validation.name.message}</div>
                    ) : (
                      ""
                    )}
                  </Form.Field>
  
                  <Form className="text-area-container">
                    <Form.Field>
                      <label className="label-item">
                        {t.customers.form.description}
                      </label>
                      <TextArea
                        error={validation.description.error && validation.description.skipped}
                        onBlur={makeOnBlur("description")}
                        autoComplete="new-password"
                        value={customerData.description}
                        onChange={onValuesChange("description")}
                        rows={4}
                        fluid
                        placeholder={t.customers.form.add_description}
                      />
                      {validation.description.error && validation.description.skipped ? (
                          <div className="label-error">{validation.description.message}</div>
                      ) : (
                          ""
                      )}
                    </Form.Field>
                  </Form>
  
                  <Form.Field>
                    <label className="label-item mt-7">
                      {t.customers.form.location}
                      <Asterisk color="#172B4D" />{" "}
                      <span
                        className="position-relative c-pointer"
                        onMouseOver={() => setTeamsTooltip(true)}
                        onMouseLeave={() => setTeamsTooltip(false)}
                      >
                        {showTeamsTooltip ? (
                          <>
                            <InfoIconBlue />
                            <ToolTip
                              color="#fff"
                              backgroundColor="#172B4D"
                              position={
                                selectedLanguage == "ar"
                                  ? "left top"
                                  : "right top"
                              }
                              show={showTeamsTooltip}
                              textBoxWidth="100px"
                              arrowAlign="center"
                              fontSize="9px"
                              fontWeight="400"
                              fontFamily={
                                selectedLanguage == "ar"
                                  ? "Noto Kufi Arabic"
                                  : "Roboto"
                              }
                              padding="4px 14px 4px 7px"
                              lineHeight="16px"
                              borderRadius="6px"
                              static
                              moveDown="0px"
                            >
                              <span className="work-order-preview-tooltip parts">
                                {t.customers.form.served}
                              </span>
                            </ToolTip>
                          </>
                        ) : (
                          <InfoIcon />
                        )}
                      </span>
                    </label>
                    <div className="flexbox align-items-start">
                      <Dropdown
                        placeholder={t.customers.form.add_location}
                        noResultsMessage={t.common.no_results_found}
                        fluid
                        selection
                        className="people-dropdown mb-0"
                        multiple
                        search={(options, query) => {
                          const filteredOptions = [];
                          const addedKeys = new Set(); // To track and avoid duplicate entries
  
                          options.forEach((option) => {
                            const isParent = !option.parentId;
                            const matches = option.text
                              .toLowerCase()
                              .includes(query.toLowerCase());
  
                            // If the parent matches, add it and all related sub-locations
                            if (isParent && matches) {
                              if (!addedKeys.has(option.key)) {
                                filteredOptions.push(option);
                                addedKeys.add(option.key);
                              }
                              options.forEach((subOption) => {
                                if (
                                  subOption.parentId === option.key &&
                                  !addedKeys.has(subOption.key)
                                ) {
                                  filteredOptions.push(subOption);
                                  addedKeys.add(subOption.key);
                                }
                              });
                            }
                            // If a sub-location matches, add both the sub-location and its parent
                            else if (!isParent && matches) {
                              const parentOption = options.find(
                                (opt) => opt.key === option.parentId
                              );
                              if (
                                parentOption &&
                                !addedKeys.has(parentOption.key)
                              ) {
                                filteredOptions.push(parentOption);
                                addedKeys.add(parentOption.key);
                              }
                              if (!addedKeys.has(option.key)) {
                                filteredOptions.push(option);
                                addedKeys.add(option.key);
                              }
                            }
                          });
  
                          return filteredOptions;
                        }}
                        options={options.locations.options}
                        value={customerData.location}
                        onChange={onValuesChange("location")}
                        error={
                          validation.location.error && validation.location.skipped
                        }
                        onBlur={(e) => {
                          if (
                            validation.location.pattern(customerData.location)
                          ) {
                            setValidation({
                              ...validation,
                              location: {
                                ...validation.location,
                                error: false,
                                skipped: true,
                              },
                            });
                          } else {
                            setValidation({
                              ...validation,
                              location: {
                                ...validation.location,
                                error: true,
                                skipped: true,
                              },
                            });
                          }
                        }}
                      />
                      {userPermissions?.location?.create &&
                      userPermissions?.location?.view ? (
                        <div
                          className="add-location ml-2 mr-2 p-1 d-flex align-items-center justify-content-center c-pointer"
                          onClick={() => {
                            setToggleAsideModal(true);
                            setToggleAddModal(false);
                          }}
                          // style={{ backgroundColor: "#E9F2FF", height: "37px" }}
                        >
                          <AddIcon />
                        </div>
                      ) : null}
                    </div>
                    {validation.location.error && validation.location.skipped ? (
                      <div className="label-error">
                        {validation.location.message}
                      </div>
                    ) : (
                      ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item mt-1">
                      {t.customers.form.phone}
                      <Asterisk color="#172B4D" />
                    </label>
                    <PhoneInput
                      defaultCountry={"jo"}
                      value={customerData.phone}
                      placeholder={t.customers.form.add_number}
                      onChange={(value) => {
                        if (!phone) {
                          setPhone(true);
                          return;
                        }
                        setCustomerData({
                          ...customerData,
                          phone: value || "",
                        });
                        if (customerData.isSame) {
                          setCustomerData({
                            ...customerData,
                            phone: value || "",
                            contact_phone: value || "",
                          });
                        }
                        if (!value) {
                          setValidation({
                            ...validation,
                            phone: {
                              ...validation.phone,
                              error: false,
                              skipped: false,
                              message: t.common.required_field,
                              pattern: (phone) =>
                                phone === "" || isPhoneValid(phone),
                            },
                          });
                        } else if (value && isPhoneValid(value)) {
                          setValidation({
                            ...validation,
                            phone: {
                              ...validation.phone,
                              error: false,
                              skipped: true,
                              pattern: (phone) =>
                                phone === "" || isPhoneValid(phone),
                            },
                          });
                        } else if (value && !isPhoneValid(value)) {
                          setValidation({
                            ...validation,
                            phone: {
                              ...validation.phone,
                              error: true,
                              skipped: true,
                              message: t.customers.form.invalid_phone,
                              pattern: (phone) =>
                                phone === "" || isPhoneValid(phone),
                            },
                          });
                        }
                      }}
                      error={
                        validation?.phone?.error && validation?.phone?.skipped
                      }
                    />
                    {validation?.phone?.error && validation?.phone?.skipped ? (
                      <div className="label-error">
                        {validation?.phone?.message}
                      </div>
                    ) : (
                      ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item mt-1">
                      {t.customers.form.email}
                      <Asterisk color="#172B4D" />
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_email}
                      value={customerData.email}
                      onChange={onValuesChange("email")}
                      className="email-password-ltr"
                      error={validation.email.error && validation.email.skipped}
                      onBlur={makeOnBlur("email")}
                    />
                    {validation.email.error && validation.email.skipped ? (
                      <div className="label-error">
                        {validation.email.message}
                      </div>
                    ) : (
                      ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item mt-1">
                      {t.customers.form.website}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_website}
                      value={customerData.website}
                      error={validation.website.error && validation.website.skipped}
                      onBlur={makeOnBlur("website")}
                      onChange={onValuesChange("website")}
                    />
                    {validation.website.error && validation.website.skipped ? (
                        <div className="label-error">
                          {validation.website.message}
                        </div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item mt-1">
                      {t.customers.form.service_type}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_service_type}
                      value={customerData.serviceType}
                      error={validation.serviceType.error && validation.serviceType.skipped}
                      onBlur={makeOnBlur("serviceType")}
                      onChange={onValuesChange("serviceType")}
                    />
                    {validation.serviceType.error && validation.serviceType.skipped ? (
                        <div className="label-error">
                          {validation.serviceType.message}
                        </div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field
                    className="industry-type"
                    // style={{ minHeight: "71px" }}
                  >
                    <label className="label-item mt-1">{t.common.industry} <Asterisk color="#172B4D" />{" "}</label>
                    <Dropdown
                      placeholder={t.customers.form.add_industry}
                      noResultsMessage={t.common.no_results_found}
                      fluid
                      clearable
                      error={validation.industry.error && validation.industry.skipped}
                      onBlur={makeOnBlur("industry", (cd) => cd.Industry)}
                      selection
                      search
                      options={options.Industry}
                      value={customerData.Industry}
                      onChange={onValuesChange("Industry")}
                    />
                    {validation.industry.error && validation.industry.skipped ? (
                        <div className="label-error">{validation.industry.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Divider />
  
                  <div className="billing-info mt-7  d-flex">
                    <ContactInfoIcon />
                    <p
                      className={`font16 mt-1 required-text ${
                        selectedLanguage == "en" ? "ml-2" : "mr-2"
                      }`}
                    >
                      {t.customers.form.contact_information}
                    </p>
                  </div>
  
                  <Form.Field>
                    <label className="label-item mt-8">
                      {t.customers.contact_name}
                    </label>
                    <Input
                      disabled={customerData.isSame}
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_contact_name}
                      value={customerData.contact_name}
                      error={validation.contact_name.error && validation.contact_name.skipped}
                      onBlur={makeOnBlur("contact_name")}
                      onChange={onValuesChange("contact_name")}
                    />
                    {validation?.contact_phone?.error &&
                    validation?.contact_phone?.skipped ? (
                        <div className="label-error">
                          {validation?.contact_phone?.message}
                        </div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item mt-1">
                      {t.customers.contact_phone}
                    </label>
                    <PhoneInput
                      disabled={customerData.isSame}
                      disableDialCodePrefill={!customerData.isSame ? true : false}
                      defaultCountry="jo"
                      value={customerData.contact_phone}
                      placeholder={t.customers.form.add_number}
                      onChange={(value) => {
                        if (!phone) {
                          setPhone(true);
                          return;
                        }
                        setCustomerData({
                          ...customerData,
                          contact_phone: value || "",
                        });
                        if (!value) {
                          setValidation({
                            ...validation,
                            contact_phone: {
                              ...validation.contact_phone,
                              error: false,
                              skipped: false,
                              message: t.common.required_field,
                              pattern: (phone) =>
                                phone === "" || isPhoneValid(phone),
                            },
                          });
                        } else if (value && isPhoneValid(value)) {
                          setValidation({
                            ...validation,
                            contact_phone: {
                              ...validation.contact_phone,
                              error: false,
                              skipped: true,
                              pattern: (phone) =>
                                phone === "" || isPhoneValid(phone),
                            },
                          });
                        } else if (value && !isPhoneValid(value)) {
                          setValidation({
                            ...validation,
                            contact_phone: {
                              ...validation.contact_phone,
                              error: true,
                              skipped: true,
                              message: t.customers.form.invalid_phone,
                              pattern: (phone) =>
                                phone === "" || isPhoneValid(phone),
                            },
                          });
                        }
                      }}
                      error={
                        validation?.contact_phone?.error &&
                        validation?.contact_phone?.skipped
                      }
                    />
                    {validation?.contact_phone?.error &&
                    validation?.contact_phone?.skipped ? (
                      <div className="label-error">
                        {validation?.contact_phone?.message}
                      </div>
                    ) : (
                      ""
                    )}
                  </Form.Field>
  
                  <Form.Field
                    className="industry-type"
                    // style={{ minHeight: "71px" }}
                  >
                    <label className="label-item mt-1">
                      {t.customers.contact_email}
                    </label>
                    <Input
                      disabled={customerData.isSame}
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_contact_email}
                      value={customerData.contact_email}
                      onChange={onValuesChange("contact_email")}
                      className="email-password-ltr"
                      error={
                        validation.contact_email.error &&
                        !customerData.isSame &&
                        validation.contact_email.skipped
                      }
                      onBlur={makeOnBlur("contact_email")}
                    />
                    {validation.contact_email.error &&
                    !customerData.isSame &&
                    validation.contact_email.skipped ? (
                      <div className="label-error">
                        {validation.contact_email.message}
                      </div>
                    ) : (
                      ""
                    )}
                  </Form.Field>
  
                  <div className="mt-4 mb-4">
                    <Checkbox
                      checked={customerData.isSame}
                      label={t.customers.same_info}
                      onChange={(e, value) => {
                        if (value.checked) {
                          setCustomerData({
                            ...customerData,
                            isSame: true,
                            contact_email: customerData.email,
                            contact_phone: customerData.phone,
                            contact_name: customerData.name,
                          });
                        } else {
                          setCustomerData({
                            ...customerData,
                            isSame: false,
                            contact_email: "",
                            contact_phone: "",
                            contact_name: "",
                          });
                        }
                      }}
                    />
                  </div>
                </div>
                <div className={activePane === 1 ? "d-block" : "d-none"}>
                  <div
                    className={`billing-info mt-7 ${
                      selectedLanguage == "en" ? "" : ""
                    }`}
                  >
                    <BillingInfoIcon />
                    <span
                      className={`font16 required-text ${
                        selectedLanguage == "en" ? "ml-2" : "mr-2"
                      }`}
                    >
                      {t.customers.form.billing_information}
                    </span>
                  </div>
  
                  <Form.Field>
                    <label className="label-item mt-7">
                      {t.customers.form.name}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_name}
                      value={customerData.billing_name}
                      onChange={onValuesChange("billing_name")}
                      error={validation.billing_name.error && validation.billing_name.skipped}
                      onBlur={makeOnBlur("billing_name")}
                    />
                    {validation.billing_name.error && validation.billing_name.skipped ? (
                        <div className="label-error">{validation.billing_name.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field autoComplete="off">
                    <label className="label-item">
                      {t.customers.form.country}
                    </label>
                    <Dropdown
                      placeholder={t.locations.form.country_add}
                      noResultsMessage={t.common.no_results_found}
                      fluid
                      search
                      clearable
                      selection
                      options={customerData.countries_options}
                      value={customerData.country}
                      onChange={onValuesChange("country")}
                    />
                  </Form.Field>
  
                  <Form.Field autoComplete="off">
                    <label className="label-item">{t.customers.form.city}</label>
                    <Dropdown
                      placeholder={t.locations.form.city_add}
                      noResultsMessage={t.common.no_results_found}
                      fluid
                      clearable
                      search
                      selection
                      options={customerData.cities_options}
                      value={customerData.city}
                      onChange={onValuesChange("city")}
                    />
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.postal_code}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_postal}
                      value={customerData.billing_postal_code}
                      onChange={onValuesChange("billing_postal_code")}
                      error={validation.billing_postal_code.error && validation.billing_postal_code.skipped}
                      onBlur={makeOnBlur("billing_postal_code")}
                    />
                    {validation.billing_postal_code.error && validation.billing_postal_code.skipped ? (
                        <div className="label-error">{validation.billing_postal_code.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.address}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_address}
                      value={customerData.billing_address}
                      onChange={onValuesChange("billing_address")}
                      error={validation.billing_address.error && validation.billing_address.skipped}
                      onBlur={makeOnBlur("billing_address")}
                    />
                    {validation.billing_address.error && validation.billing_address.skipped ? (
                        <div className="label-error">{validation.billing_address.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.address_line_2}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_address}
                      value={customerData.billing_addressLine2}
                      onChange={onValuesChange("billing_addressLine2")}
                      error={validation.billing_addressLine2.error && validation.billing_addressLine2.skipped}
                      onBlur={makeOnBlur("billing_addressLine2")}
                    />
                    {validation.billing_addressLine2.error && validation.billing_addressLine2.skipped ? (
                        <div className="label-error">{validation.billing_addressLine2.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.address_line_3}
                    </label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      placeholder={t.customers.form.add_address}
                      value={customerData.billing_addressLine3}
                      onChange={onValuesChange("billing_addressLine3")}
                      error={validation.billing_addressLine3.error && validation.billing_addressLine3.skipped}
                      onBlur={makeOnBlur("billing_addressLine3")}
                    />
                    {validation.billing_addressLine3.error && validation.billing_addressLine3.skipped ? (
                        <div className="label-error">{validation.billing_addressLine3.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item">{t.customers.form.rate}</label>
                    <Input
                      autoComplete="new-password"
                      fluid
                      type="number"
                      onKeyDown={(evt) => handleKeyDown(evt)}
                      min="0"
                      placeholder={t.customers.form.add_rate}
                      value={customerData.billing_rate}
                      onChange={onValuesChange("billing_rate")}
                      error={validation.billing_rate.error && validation.billing_rate.skipped}
                      onBlur={makeOnBlur("billing_rate")}
                    />
                    {validation.billing_rate.error && validation.billing_rate.skipped ? (
                        <div className="label-error">{validation.billing_rate.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
  
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.currency}
                    </label>
                    <Dropdown
                      placeholder={t.customers.form.add_currency}
                      noResultsMessage={t.common.no_results_found}
                      fluid
                      search
                      selection
                      clearable
                      options={currencies}
                      value={customerData.billing_currency}
                      onChange={onValuesChange("billing_currency")}
                    />
                  </Form.Field>
                </div>
              </div>
  
              <div className={`form-button-container mt-0`}>
                <button
                  content={t.common.cancel}
                  className="form-action-button"
                  basic
                  type="button"
                  onClick={() =>
                    initChange ? setNewCancelModal(true) : cancelHandler()
                  }
                >
                  {t.assets.form.cancel}
                </button>
                {activePane == 1 ? (
                  <button
                    content={t.common.submit}
                    primary
                    type="button"
                    onClick={createNewCustomerHandler}
                    className="form-action-button blue"
                  >
                    {t.common.submit}
                  </button>
                ) : (
                  <button
                    content={t.common.next}
                    className="form-action-button blue"
                    type="button"
                    primary
                    onClick={() => {
                      changeTab(activePane + 1);
                    }}
                  >
                    {t.common.next}
                  </button>
                )}
              </div>
            </div>
          </Resizable>
        </div>
        <div
          className={
            toggled ? "aside-modal-background active" : "aside-modal-background"
          }
          onClick={() => (initChange ? setNewCancelModal(true) : cancelHandler())}
        ></div>
  
        {toggleAsideModal && (
          <AddLocation
            toggled={toggleAsideModal}
            allIds={allIds}
            role={role}
            currentUserId={currentUserId}
            untoggle={() => {
              setToggleAsideModal(false);
              setToggleAddModal(true);
              setModalWidth(Math.max(window.innerWidth / 2, 514));
            }}
            setRefresh={setRefresh}
            refresh={refresh}
            parentLocation={null}
            fromCustomer={true}
            handleSuccess={async (res) => {
              if (!(role === "super_admin")) {
                let allLocation = [...customerData?.location];
  
                allLocation.push(res?.data?.id);
                setCustomerData({
                  ...customerData,
                  location: allLocation,
                  selectedLocation: allLocation,
                });
  
                let updatedAllIds = [...allIds];
                const [userData] = await Promise.all([getUserData(user.id)]);
  
                dispatch(props.fulfillUser(userData));
                userData?.locations?.length &&
                  userData.locations.forEach((location) => {
                    if (!updatedAllIds.some((inv) => inv == location?.id)) {
                      updatedAllIds.push(location?.id);
                    }
                  });
  
                setAllIds(updatedAllIds);
                await fetchLocationsOptions(updatedAllIds);
              } else {
                setToggleAsideModal(false);
                setToggleAddModal(true);
                let allLocation = [...customerData?.location];
  
                allLocation.push(res?.data?.id);
                setCustomerData({
                  ...customerData,
                  location: allLocation,
                  selectedLocation: allLocation,
                });
              }
            }}
          />
        )}
        <NewCancelModal
          yesCallback={() => {
            cancelHandler();
          }}
          title={t.parts.form.changes}
        >
          <p className="cancel-child"> {t.common.cancel_2statement}</p>
        </NewCancelModal>
      </>
    );
  }
  export default connect(null, auth.actions)(Add);
